import { Observable, tap } from 'rxjs';
import { AjaxConfig, AjaxResponse } from 'rxjs/ajax';

import { environment } from 'app/services/environment';
import { AppStore } from 'app/store';
import { reportAppUpdated } from 'features/core/core.slice';

import { HttpHandler } from '../http-handler';
import { Interceptor } from '../interceptor';

const VERSION_HEADER = 'x-analog-version';

export class UpdateDetectionInterceptor implements Interceptor {
    public intercept<T>(store: AppStore, req: AjaxConfig, next: HttpHandler<T>): Observable<AjaxResponse<T>> {
        return next.handle(req).pipe(
            tap((response) => {
                if (!response.responseHeaders[VERSION_HEADER]) {
                    return;
                }

                const backendVersion = response.responseHeaders[VERSION_HEADER].split(/[\n\r]+/).shift();

                if (environment.appVersion !== backendVersion) {
                    store.dispatch(reportAppUpdated());
                }
            }),
        );
    }
}
